<div class="padre" style="z-index:1001;background-color: white;position: absolute;top: 0;width:100%;height: 100%;">
    <div class="container hijo">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <span class="display-1 d-block">404 - Not found</span>
                <div class="mb-4 lead">Resource not found</div>
            </div>
        </div>
    </div>
</div>